import { Component, OnDestroy, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
  ToasterPosition,
  ToasterService,
} from 'src/app/shared/services/toaster/toaster.service';
import { VoiceService } from '../voice.service';
import { VoiceFormComponent } from '../voice-form/voice-form.component';
import { IVoice } from 'src/app/talent-litmus-core/game-core/level1-core/voice-core';
import { DEFAULT_Y_CORD } from 'src/app/shared/configs/global-values.constants';
import { ViewportScroller } from '@angular/common';

@Component({
  selector: 'app-add-voice',
  templateUrl: './add-voice.component.html',
})
export class AddVoiceComponent implements OnDestroy {
  private _unsubscribe$ = new Subject<void>();
  @ViewChild(VoiceFormComponent) voiceFormComponent: VoiceFormComponent;

  voice: IVoice;
  isInValid: boolean = true;
  adding$ = new BehaviorSubject<boolean>(false);
  isUploadDone = false;
  constructor(
    public modal: NgbActiveModal,
    public voiceService: VoiceService,
    private _toast: ToasterService,
    private _scroller: ViewportScroller,
  ) {}

  public submit(): void {
    const dataInput = this.voiceFormComponent.onSubmit();
    const query = {
      name: dataInput.name,
      url: dataInput.url,
    };
    this.adding$.next(true);
    this.voiceService
      .addVoice(query)
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe(
        (data: IVoice): void => {
          this.adding$.next(false);
          this._toast.showSuccess(
            'Voice added successfully',
            ToasterPosition.topRightSticky,
          );
          this.modal.close(true);
          this.voiceService.moveToLastPage();
          this.voiceService.setSelectedId(data?._id);
          this._scroller.scrollToPosition([0, DEFAULT_Y_CORD]);
        },
        (err) => {
          console.log(err);
          this.adding$.next(false);
          this._toast.showError(
            err?.error?.message,
            ToasterPosition.topRightSticky,
          );
        },
      );
  }

  onValidityChange(validity?: boolean): void {
    this.isInValid = validity;
  }

  uploadChange(res: boolean): void {
    this.isUploadDone = res;
  }

  ngOnDestroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }
}
